// @flow

import _ from 'lodash';

import type {
  SuggestionsState,
  SuggestionsAction
} from 'stores/flow-type/suggestion-dictionary.type';

import {
  GET_SUGGESTIONS_REQUEST,
  GET_SUGGESTIONS_SUCCESS,
  GET_SUGGESTIONS_FAILURE,
  BULK_SUGGESTIONS_REQUEST,
  BULK_SUGGESTIONS_SUCCESS,
  BULK_SUGGESTIONS_FAILURE,
  DELETE_SUGGESTIONS_REQUEST,
  DELETE_SUGGESTIONS_SUCCESS,
  DELETE_SUGGESTIONS_FAILURE,
  UPDATE_SUGGESTION_REQUEST,
  UPDATE_SUGGESTION_SUCCESS,
  UPDATE_SUGGESTION_FAILURE,
  VERIFY_CONTENT_BEFORE_IMPORT_REQUEST,
  VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS,
  VERIFY_CONTENT_BEFORE_IMPORT_FAILURE,
  IMPORT_FILE_REQUEST,
  IMPORT_FILE_SUCCESS,
  IMPORT_FILE_FAILURE,
  EXPORT_FILE_REQUEST,
  EXPORT_FILE_SUCCESS,
  EXPORT_FILE_FAILURE
} from 'stores/flow-type/suggestion-dictionary.type';

const initialState: SuggestionsState = {
  loading: false,
  success: false,
  updateSuccess: false,
  successFlag: 0, // Make sure data is updated when calling an API multiply at the same time
  error: null,
  suggestions: [],
  total: 0,
  saving: false,

  // Verify file content
  verifying: false,
  fileContentErrorCode: '',
  totalRecord: 0,

  // Import file content
  importing: false,
  totalImportedRecords: 0
};

const suggestionDictionaryReducers = (
  state: FilterDataState = initialState,
  action: SuggestionsAction
) => {
  switch (action.type) {
    // Get suggestions
    case GET_SUGGESTIONS_REQUEST:
      return { ...state, success: false, loading: true };
    case GET_SUGGESTIONS_SUCCESS: {
      const { data } = action.payload;
      const { data: suggestions, total } = data;

      return {
        ...state,
        loading: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        suggestions,
        total
      };
    }
    case GET_SUGGESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // Bulk suggestions
    case BULK_SUGGESTIONS_REQUEST:
      return { ...state, updateSuccess: false, saving: true };
    case BULK_SUGGESTIONS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        saving: false,
        updateSuccess: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        suggestions: data
      };
    }
    case BULK_SUGGESTIONS_FAILURE:
      return {
        ...state,
        saving: false,
        updateSuccess: false,
        error: action.payload
      };

    // Delete suggestions
    case DELETE_SUGGESTIONS_REQUEST:
      return { ...state, updateSuccess: false, deleting: true };
    case DELETE_SUGGESTIONS_SUCCESS: {
      return {
        ...state,
        deleting: false,
        updateSuccess: true,
        successFlag: 1 - state.successFlag,
        error: undefined
      };
    }
    case DELETE_SUGGESTIONS_FAILURE:
      return {
        ...state,
        deleting: false,
        updateSuccess: false,
        error: action.payload
      };

    // Update suggestion
    case UPDATE_SUGGESTION_REQUEST:
      return { ...state, updateSuccess: false, saving: true };
    case UPDATE_SUGGESTION_SUCCESS: {
      const { data: response, actionName } = action.payload;

      // Skip update suggestions if action is change status
      // Because the status of selected suggestion has been changed before
      if (actionName === 'changeStatus') {
        return {
          ...state,
          saving: false,
          updateSuccess: true,
          successFlag: 1 - state.successFlag,
          error: undefined
        };
      }

      return {
        ...state,
        saving: false,
        updateSuccess: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        suggestions: response.data
      };
    }
    case UPDATE_SUGGESTION_FAILURE:
      return {
        ...state,
        saving: false,
        updateSuccess: false,
        error: action.payload
      };

    // Verify file content
    case VERIFY_CONTENT_BEFORE_IMPORT_REQUEST:
      return { ...state, success: false, verifying: true, fileContentErrorCode: '' };
    case VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        verifying: false,
        totalRecord: data.total,
        fileContentErrorCode: ''
      };
    }
    case VERIFY_CONTENT_BEFORE_IMPORT_FAILURE:
      return {
        ...state,
        success: false,
        error: action.payload,
        verifying: false,
        fileContentErrorCode: action.payload.errorCode ? action.payload.errorCode : 'ORTHER'
      };

    // Import suggestions
    case IMPORT_FILE_REQUEST:
      return { ...state, updateSuccess: false, importing: true };
    case IMPORT_FILE_SUCCESS: {
      const { data: response } = action.payload;
      const totalImportedRecords = _.isArray(response.data) ? response.data.length : 0;

      return {
        ...state,
        importing: false,
        updateSuccess: true,
        successFlag: 1 - state.successFlag,
        error: undefined,
        totalImportedRecords
      };
    }
    case IMPORT_FILE_FAILURE:
      return {
        ...state,
        importing: false,
        updateSuccess: false,
        error: action.payload
      };

    // Export suggestions
    case EXPORT_FILE_REQUEST:
      return { ...state, success: false, exporting: true };
    case EXPORT_FILE_SUCCESS: {
      return {
        ...state,
        exporting: false,
        success: true,
        successFlag: 1 - state.successFlag,
        error: undefined
      };
    }
    case EXPORT_FILE_FAILURE:
      return {
        ...state,
        exporting: false,
        success: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default suggestionDictionaryReducers;
